// extracted by mini-css-extract-plugin
export var cardBanner = "Banner-module--cardBanner--2e857";
export var cardHeader = "Banner-module--cardHeader--6ff06";
export var tagsContainer = "Banner-module--tagsContainer--12db7";